'use strict';

exports.mapSeries = function(items, process, callback) {
    var count = items.length;
    var current = 0;
    var results = [];

    function done(err, result) {
        if (err) {
            return callback(err);
        }

        current++;
        results.push(result);
        if(current !== count){
            process(items[current], done);
        }else{
            callback(null, results);
        }
    }

    process(items[current], done);
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/async.js
// module id = 544
// module chunks = 0